/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'email-clock-stroke': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<desc>envelope postal schedule time history</desc><g stroke-linecap="round" stroke-width="1.5" _stroke="currentColor" _fill="none" stroke-linejoin="round"><path pid="0" d="M17.25 11.25a6 6 0 100 12 6 6 0 100-12z"/><path pid="1" d="M19.9 17.25h-2.66v-2.66M8.25 15.75h-6l-.01-.001a1.51 1.51 0 01-1.5-1.5V2.238c0-.83.67-1.5 1.5-1.5h18-.01c.82-.01 1.5.67 1.5 1.5 0 0 0 0 0 0v6.75"/><path pid="2" d="M21.411 1.3l-8.15 6.26v-.01a3.33 3.33 0 01-4.04 0L1.07 1.28"/></g>'
  }
})
